<template>
    <div>

    <tops/>
    <div class="fwtk_box">
        <!-- <img class="wenwen_de_img" src="../assets/heroes_terrains_clean_bg.png" alt=""> -->
        <h1 style="color: #323232; font-family: SimHei; position: relative; z-index: 20; margin-top: 30px; margin-bottom: 20px;">《服务条款》</h1>
        <div class="zc_text" style="font-family: SimHei; line-height: 1.8;">
            <h3 class="section-title">服务条款</h3>
            <p class="text-content">
                以下条款和条件包括我们的《可接受使用政策》（统称“[使用条款]”），是您与四川活力糖科技有限公司及其子公司和关联公司（[四川活力糖科技有限公司]或“我们”）之间具有约束力的法律协议，管理您对以下内容的使用：
            </p>
            <p class="text-content">
                1. 网站位于vitalitysugar-game.com（[网站]），包括从网站上可访问或可下载的所有服务、功能和内容。
            </p>
            <p class="text-content">
                2. 您通过第三方网站或来源获得、下载或以其他方式访问的任何其他四川活力糖科技有限公司的应用程序（包括移动应用程序）、服务或产品。
            </p>
            <p class="text-content">
                (i)和（ii），[服务]。严格来说，该服务仅供消费者使用，不得供18岁以下的用户使用。
            </p>
            <p class="text-content">
                请同时查看我们的隐私政策，该政策会告知我们如何使用您的个人信息。
            </p>
            <p class="text-content">
                我们建议您打印一份这些使用条款以供将来参考。
            </p>
            <h3 class="section-title">A. 您接受使用条款：</h3>
            <p class="text-content">
                请仔细阅读这些使用条款，它们影响您的法律权利和义务。这些使用条款告诉您我们是谁，我们将如何为您提供服务，您和我们如何更改或终止此合同，如果出现问题该怎么办以及其他重要信息。
            </p>
            <p class="text-content">
                通过注册用户账户以使用本服务和/或发布在线内容（“账户”）或以其他方式使用本服务，您声明(1)您已年满17岁（在欧盟/欧洲经济区为18岁及以上），(2)您完全理解和同意这些使用条款，以及(3)如果您年龄在13至18岁之间，您的法定监护人已审查并同意这些使用条款。
            </p>
            <p class="text-content">
                如果您不理解或不同意这些使用条款，请勿使用本服务。如果您不同意这些使用条款，则您无权访问或使用本服务。禁止使用本服务的，本服务无效。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司保留随时自行决定更改或修改这些使用条款的权利。任何此类更改或修改将在网站或移动应用程序发布后立即生效，您在这些使用条款发布后继续使用服务即表示接受并同意这些更改或修改。每次使用我们的服务时，请务必查看使用条款，以确保您了解当时适用的条款。如果您对任何更改或修改有异议，唯一的解决办法是停止使用服务。您同意，四川活力糖科技有限公司不对您或任何第三方因这些使用条款的任何更改或修改而产生的任何责任负责。
            </p>
            <p class="text-content">
                除四川活力糖科技有限公司另有明确说明的服务付费部分外，四川活力糖科技有限公司保留权利，在不另行通知且不承担责任的情况下，增加、更改、暂停或终止服务，或服务的任何方面或功能，以反映我们产品的变化、用户需求和/或业务优先事项。
            </p>
            <h3 class="section-title">B. 关于我们和如何联系我们：</h3>
            <ul class="text-content">
                <li>1. 我们是谁：我们是四川活力糖科技有限公司，注册于[中国]。</li>
                <li>2. 如何联系我们：您可以通过写信给我们来联系我们bravedefense@yeah.net</li>
                <li>3. 我们如何联系您：如果我们必须联系您，我们将通过您在账户中提供的电子邮件与您联系。</li>
                <li>4. “写作”包括电子邮件。当我们在这些使用条款中使用“写作”或“书面”时，这包括电子邮件。</li>
            </ul>
            <h3 class="section-title">C. 与其他协议的关系：</h3>
            <p class="text-content">
                您使用服务或部分服务可能还受一个或多个相关第三方协议（[第三方协议]）的条款和条件约束，例如通过第三方网站或来源（如谷歌；苹果）下载或访问服务中应用程序的协议。在任何第三方协议与本使用条款关于四川活力糖科技有限公司或服务任何方面的冲突情况下，本使用条款将具有约束力。
            </p>
            <h3 class="section-title">D. 用户帐户：</h3>
            <p class="text-content">
                在我们注册帐户时，您可能需要提供有关您的信息，以便使用服务。您同意：
            </p>
            <ul class="text-content">
                <li>1. 根据服务提示，提供关于您的真实、准确、最新和完整的信息。</li>
                <li>2. 维护并及时更新此类数据以保持其真实、准确、最新和完整。如果您提供的任何信息不真实、不准确、不完整或不符合当前情况，您将被视为违反这些使用条款，四川活力糖科技有限公司有权暂停或终止您的账户，并拒绝您当前及未来使用服务的所有请求。</li>
            </ul>
            <p class="text-content">
                每位服务用户每台安装移动操作系统的电子设备（“设备”）最多允许拥有一个账户。您不得出售、交易或以其他方式转让或分配您的账户给任何第三方，除非本协议另有明确规定。您有责任维护密码和账户的保密性，并同意不向任何其他方提供您的登录信息。您需对在不知情的情况下或知情的情况下，使用您的密码或账户进行的所有活动负全责。您同意立即通知四川活力糖科技有限公司任何未经授权使用您的密码或账户或其他安全漏洞的情况。
            </p>
            <h3 class="section-title">E. 使用服务的权利；订阅：</h3>
            <p class="text-content">
                使用权：在完全遵守本《使用条款》的前提下，四川活力糖科技有限公司特此授予您有限的、可撤销的、非独占的、不可转让的、不可再许可的使用权，仅供您个人非商业用途，在单一设备上使用和显示：
            </p>
            <ul class="text-content">
                <li>1. 从网站免费访问的服务部分，或经 四川活力糖科技有限公司  授权，从第三方网站或来源免费访问的服务部分，例如移动应用程序。</li>
                <li>2. 但前提是您已支付了适用费用并满足了适用条件，您可获得基于支付的其他服务部分。</li>
            </ul>
            <p class="text-content">
                订阅：您可能需要支付费用以访问作为订阅提供的服务的某些部分。您应对所有此类付款及相关支付义务负责，这些义务均受本使用条款约束。您支付的所有款项均须遵守本使用条款及相关支付服务的条件。四川活力糖科技有限公司不对任何由第三方处理的交易或向第三方支付的款项负责。您确认，四川活力糖科技有限公司提供的与服务相关的订阅的价格和可用性随时可能发生变化。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司可能会不时向您提供自动、定期或基于订阅的付款方式。如四川活力糖科技有限公司这样做，您同意（受适用法律和法规的约束）：
            </p>
            <ul class="text-content">
                <li>1. 此类购买或付款通常由您预先支付；</li>
                <li>2. 您授权四川活力糖科技有限公司将您选择的付款方式的信息（例如，信用卡信息）保存在我们的系统中，并在相关时间段向您选择的付款方式收取相关费用；</li>
                <li>3. 如果通过您选择的支付方式收到的任何款项因任何原因被拒绝、扣留或未支付，四川活力糖科技有限公司可能不会向您提供或暂停提供相关服务，直至款项得到妥善处理；您需对我们因此类拒绝、扣留或未支付而产生的费用、成本、开支或其他金额负责（我们有权自动向您收取这些费用）。</li>
            </ul>
            <p class="text-content">
                您同意，您向四川活力糖科技有限公司支付的任何与您的订阅相关的款项均为最终且不可退还的，除非本使用条款另有规定。否则，在任何情况下，四川活力糖科技有限公司均无需为您与本服务相关的任何付款（无论是否使用）提供退款。
            </p>
            <p class="text-content">
                如果您认为四川活力糖科技有限公司向您收取了错误费用，并且根据适用的法律法规，请联系四川活力糖科技有限公司bravedefense@yeah.net在相关收费日期后30天内，对于任何错误收费，将不予退款。
            </p>
            <p class="text-content">
                支付处理服务由第三方服务提供，通过这些服务进行购买。所有购买都可能受到税费和其他费用的影响，包括但不限于，但不限于，外汇费用或根据地点的价格差异。
            </p>
            <p class="text-content">
                转移您的账户：使用我们的移动应用程序时，您只能在明确授权和由四川活力糖科技有限公司通过服务授权的情况下，将您的账户或部分服务从一个设备转移到另一个设备。只要您是新旧设备以及被转移账户的所有者，您就可以将服务转移到新设备上。
            </p>
            <p class="text-content">
                您同意不这样做，也不试图这样做，
            </p>
            <ul class="text-content">
                <li>1. 使用本服务进行除本服务条款明确允许的以外的任何用途或目的</li>
                <li>2. 复制、改编、修改、准备基于服务或服务的任何部分的衍生作品、分发、授权、销售、转让、公开展示、公开表演、传输或以其他方式利用服务或服务的任何部分，但本使用条款明确允许的除外。</li>
            </ul>

            <h3 class="section-title">E.使用服务的权利；订阅：</h3>
            <p class="text-content">
                使用权：在完全遵守本《使用条款》的前提下，四川活力糖科技有限公司特此授予您有限的、可撤销的、非独占的、不可转让的、不可再许可的使用权，仅供您个人非商业用途，在单一设备上使用和显示：
            </p>
            <p class="text-content">
                1.从网站免费访问的服务部分，或经 四川活力糖科技有限公司  授权，从第三方网站或来源免费访问的服务部分，例如移动应用程序，以及
            </p>
            <p class="text-content">
                2.但前提是您已支付了适用费用并满足了适用条件，您可获得基于支付的其他服务部分。
            </p>
            <h3 class="section-title">订阅：</h3>
            <p class="text-content">
                您可能需要支付费用以访问作为订阅提供的服务的某些部分。您应对所有此类付款及相关支付义务负责，这些义务均受本使用条款约束。您支付的所有款项均须遵守本使用条款及相关支付服务的条件。四川活力糖科技有限公司不对任何由第三方处理的交易或向第三方支付的款项负责。您确认，四川活力糖科技有限公司提供的与服务相关的订阅的价格和可用性随时可能发生变化。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司可能会不时向您提供自动、定期或基于订阅的付款方式。如四川活力糖科技有限公司这样做，您同意（受适用法律和法规的约束）：
            </p>
            <ul class="text-content lidian">
                <li>此类购买或付款通常由您预先支付；</li>
                <li>您授权四川活力糖科技有限公司将您选择的付款方式的信息（例如，信用卡信息）保存在我们的系统中，并在相关时间段向您选择的付款方式收取相关费用；</li>
                <li>如果通过您选择的支付方式收到的任何款项因任何原因被拒绝、扣留或未支付，四川活力糖科技有限公司可能不会向您提供或暂停提供相关服务，直至款项得到妥善处理；您需对我们因此类拒绝、扣留或未支付而产生的费用、成本、开支或其他金额负责（我们有权自动向您收取这些费用）。</li>
            </ul>
            <p class="text-content">
                您同意，您向四川活力糖科技有限公司支付的任何与您的订阅相关的款项均为最终且不可退还的，除非本使用条款另有规定。否则，在任何情况下，四川活力糖科技有限公司均无需为您与本服务相关的任何付款（无论是否使用）提供退款。
            </p>
            <p class="text-content">
                如果您认为四川活力糖科技有限公司向您收取了错误费用，并且根据适用的法律法规，请联系四川活力糖科技有限公司bravedefense@yeah.net在相关收费日期后30天内，对于任何错误收费，将不予退款。
            </p>
            <p class="text-content">
                支付处理服务由第三方服务提供，通过这些服务进行购买。所有购买都可能受到税费和其他费用的影响，包括但不限于，但不限于，外汇费用或根据地点的价格差异。
            </p>
            <h3 class="section-title">转移您的账户：</h3>
            <p class="text-content">
                使用我们的移动应用程序时，您只能在明确授权和由四川活力糖科技有限公司通过服务授权的情况下，将您的账户或部分服务从一个设备转移到另一个设备。只要您是新旧设备以及被转移账户的所有者，您就可以将服务转移到新设备上。
            </p>
            <p class="text-content">
                您同意不这样做，也不试图这样做，
            </p>
            <ul class="text-content">
                <li>使用本服务进行除本服务条款明确允许的以外的任何用途或目的</li>
                <li>复制、改编、修改、准备基于服务或服务的任何部分的衍生作品、分发、授权、销售、转让、公开展示、公开表演、传输或以其他方式利用服务或服务的任何部分，但本使用条款明确允许的除外。</li>
            </ul>
            <p class="text-content">
                除本使用条款中明确授予的许可和权利外，四川活力糖科技有限公司或其许可方所拥有的或控制的任何知识产权均未以明示或暗示的方式授予您任何许可或权利。本条款E的普遍性不受限制，四川活力糖科技有限公司保留根据这些条款和条件修改本条款及本使用条款其他部分中规定的许可和限制的权利，包括但不限于收取此类许可费用。
            </p>
            <h3 class="section-title">F.服务材料、所有权、商标和反馈：</h3>
            <p class="text-content">
                服务材料：除您的内容（如下定义）和本使用条款另有明确规定外，四川活力糖科技有限公司及其许可方拥有并保留对服务和服务材料的所有权利、所有权和利益。
            </p>
            <p class="text-content">
                [服务资料]指服务中包含的所有信息和材料，包括但不限于：照片；图形；版式；文字；图像；音频；视频；设计；广告文案；数据；徽标；域名；商标、服务标志、商号及其他来源标识；任何可版权保护的材料，包括软件；服务或其部分的[外观和感觉]；服务或其部分材料的编纂、组装和排列；以及用户内容。您承认并同意，通过下载服务资料或购买任何虚拟货币或虚拟商品（下文定义），您不会获得任何所有权。
            </p>
            <p class="text-content">
                您承认并同意，服务材料受适用的知识产权和其他法律保护，在美国及其他司法管辖区，其使用、复制和传播可能受到限制。本使用条款未明确授予的所有权利均由四川活力糖科技有限公司及其许可方保留，除非通过明示、暗示或其他方式授予许可，否则不授予任何许可。您同意不得以任何方式占用、授权、修改、发布、复制、出售、转让、传输或以其他方式利用服务或服务材料的任何部分，但您的内容（下文定义）除外，您也不会试图这样做，除非得到四川活力糖科技有限公司的书面明确许可，以及适用的服务材料所有者的书面明确许可（您需向其单独负责获取许可）。
            </p>
            <h3 class="section-title">四川活力糖科技有限公司标志：</h3>
            <p class="text-content">
                四川活力糖科技有限公司、四川活力糖科技有限公司标志及其他四川活力糖科技有限公司标志和产品及服务名称均为四川活力糖科技有限公司（以下简称[四川活力糖科技有限公司标志]）的商标和服务标志，归四川活力糖科技有限公司所有。除本协议另有明确规定外，未经四川活力糖科技有限公司 事先书面许可，您不得以任何方式使用或展示这些商标。服务中出现的所有第三方商标和服务标志均为各自所有者的财产，所有权利均予保留。禁止在其他网站上使用任何四川活力糖科技有限公司商标或服务标志作为[元标签]。
            </p>
            <p class="text-content">
                您不得使用四川活力糖科技有限公司的商标诋毁四川活力糖科技有限公司及其服务。您不得以任何可能损害四川活力糖科技有限公司商标商誉的方式使用该商标。所有因使用四川活力糖科技有限公司的商标而产生的商誉将完全归四川活力糖科技有限公司所有。
            </p>
            <h3 class="section-title">反馈：</h3>
            <p class="text-content">
                如果您向四川活力糖科技有限公司提供关于服务的评论、建议或反馈（统称为[反馈]），您同意这些反馈是四川活力糖科技有限公司的专属财产，并且您特此将所有权利、所有权和利益转让给四川活力糖科技有限公司。您同意，除非法律另有禁止，四川活力糖科技有限公司可以以任何方式、出于任何目的使用、出售、披露和利用这些反馈，不受限制且无需向您支付任何费用。
            </p>
            
            <h3 class="section-title">G.用户内容：</h3>
            <p class="text-content">
                服务可能会邀请或允许您和其他用户创建、提交、发布、展示、传输、执行、出版或分发通信、内容和材料（包括但不限于文字、文章、照片、图形、图像、评论、个人身份信息等），包括通过电子邮件或在线论坛、留言板、消息服务、博客或其他服务功能或部分功能向四川活力糖科技有限公司及其他服务用户提供上述内容（统称为[用户内容]）。四川活力糖科技有限公司可以但没有义务接受、显示、审查、维护或以其他方式利用任何用户内容。
            </p>
            <p class="text-content">
                您理解，与服务相关的所有用户内容均由该用户内容的来源人全权负责。四川活力糖科技有限公司保留但没有义务预先审查、检查、评估或以其他方式监控任何用户内容的准确性、完整性、及时性、有效性、合法性、得体性、质量、完整性、实用性或其他任何质量。四川活力糖科技有限公司不对用户内容作出任何保证或任何形式的担保。您明白，使用服务的风险由您自行承担，通过使用服务，您可能会接触到令人反感、不雅、令人不安或不符合您需求的用户内容。您同意，您必须自行评估并承担使用任何与服务相关的用户内容所伴随的所有风险。在任何情况下，四川活力糖科技有限公司均不对通过服务提供的任何用户内容负责，包括但不限于此类用户内容中的任何错误或遗漏，或任何形式的损失或损害。由于使用了此类用户内容而产生的问题
            </p>
            <p class="text-content">
                尽管有上述规定，四川活力糖科技有限公司保留其自行决定的权利，在任何时候，出于任何原因，包括但不限于违反这些使用条款，或无故，预先筛选、审查、监控、拒绝、移除服务中的任何用户内容（包括但不限于您的内容），审查、编辑、修改、删除、禁用访问或以其他方式使其不可用。如果您认为用户内容违反了这些使用条款或其他不当行为，请点击评论框旁的“举报”按钮或通过联系我们向四川活力糖科技有限公司报告。bravedefense@yeah.net
            </p>
            <h3 class="section-title">H.您的内容：</h3>
            <p class="text-content">
                您在与服务相关的场合提供的用户内容，在此称为[您的内容]。您同意您的内容不保密。您进一步同意，在您的帐户终止后，我们可能会删除您的内容，并且不会以合并格式将您的内容归还给您。
            </p>
            <p class="text-content">
                您声明并保证，您的内容完全原创，您是您内容的唯一所有者，包括授予本使用条款中所述的所有权利和许可的权利，四川活力糖科技有限公司在行使这些权利和许可时不会产生任何第三方义务或责任。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司不声称对您的内容拥有任何所有权，本使用条款中的任何内容均不会被视为限制您使用和利用您的内容的权利。
            </p>
            <p class="text-content">
                为了在应用程序上展示您的内容供阅读，您特此授予四川活力糖科技有限公司一项全球性的、不可撤销的、永久的、非独占的、可转让的、免版税的许可（包括再许可的权利），允许您通过服务或其他方式使用、复制、分发、授权、转让、公开展示、公开表演、传输、流媒体、广播及其他方式利用您的内容。您还授予四川活力糖科技有限公司再许可的权利，并授权他人行使本使用条款授予四川活力糖科技有限公司的任何权利。在您的账户被终止和删除的情况下，您进一步永久且不可撤销地授予四川活力糖科技有限公司无条件使用和利用您的账户名称、个人形象和肖像（如隐私政策所述）的权利，与任何用户内容相关联，无需您承担任何义务。请查阅我们的隐私政策，以确保您了解我们如何处理您的个人数据。在法律允许的范围内，您放弃并/或同意不主张任何署名权和/或任何您在您的内容中可能拥有的所谓道德权利，无论您的内容是否被修改或以不令人满意的方式更改
            </p>
            <p class="text-content">
                四川活力糖科技有限公司没有义务监控或执行您的知识产权或您的内容。
            </p>
            <h3 class="section-title">I.知识产权</h3>
            <p class="text-content">
                除用户内容外，四川活力糖科技有限公司提供的与服务相关的任何内容可能受版权或其他知识产权保护，归四川活力糖科技有限公司或第三方所有。您在使用服务时，不会获得任何版权或其他权益。
            </p>
            <p class="text-content">
                您明确不得利用本服务进行盈利或牟利。四川活力糖科技有限公司对本《使用条款》中未明确授予您的所有权利予以保留。
            </p>
            <h3 class="section-title">J.著作权或其他知识产权侵权行为的声明和处理程序</h3>
            <p class="text-content">
                四川活力糖科技有限公司尊重他人的知识产权，非常重视知识产权保护，我们要求用户也这样做。在服务中或通过服务进行的侵权行为绝不容忍。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司知识产权政策是，根据知识产权所有者或其代理人的通知，删除或禁用四川活力糖科技有限公司善意认为通过服务提供的、侵犯第三方知识产权的材料的访问权。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司有权在收到一次侵权声明通知后或根据四川活力糖科技有限公司自身决定终止任何用户的账户。
            </p>
            <p class="text-content">
                如果您认为通过或使用服务提供的任何内容侵犯了您拥有或控制的知识产权，请立即向以下版权代理人发送包含以下信息的“侵权声明”。您的侵权声明可能会由四川活力糖科技有限公司与涉嫌侵犯您拥有或控制权利的用户共享，您同意四川活力糖科技有限公司进行此类披露。您的通信必须包括以下主要内容：
            </p>
            <ul class="text-content lidian">
                <li>被授权代表作品（或作品）所有者行事的个人的物理或电子签名；</li>
                <li>识别侵权作品或材料，或者如果一个通知涵盖多个作品，则列出此类作品的代表性清单；</li>
                <li>识别被控侵权或涉嫌侵权活动的特定材料，并要求删除该等材料或禁止访问该等材料，以及合理充足的资料，使四川活力糖科技有限公司能够找到该等材料；</li>
                <li>信息合理充足，允许 四川活力糖科技有限公司联系到您，例如您的地址、电话号码以及如果有的话，您可能联系的电子邮件地址；</li>
                <li>声明你真诚地相信，以被投诉的方式使用该材料未经版权所有者、其代理人或法律授权；以及</li>
                <li>声明通知中的信息是准确的，并且根据伪证罪的处罚，您被授权代表据称被侵犯的独占权利的所有者采取行动。</li>
            </ul>
            <p class="text-content">
                您应该咨询自己的律师和/或查看17 U.S.C. ？512以确认您提供有效侵权声明的义务。
            </p>
            <p class="text-content">
                 四川活力糖科技有限公司  版权代理(DMCA指定代理）负责接收侵权索赔通知，联系方式如下：
            </p>
            <p class="text-content">
                通过电子邮件：bravedefense@yeah.net
            </p>
            <p class="text-content">
                关于反通知，如果您收到四川活力糖科技有限公司的通知，告知您在服务中提供的材料已被指控侵权，则您有权向四川活力糖科技有限公司提交所谓的[反通知]。要生效，反通知必须以书面形式提交，并通过上述方法之一提供给四川活力糖科技有限公司 版权代理人，内容应包括以下主要信息：
            </p>
            <ul class="text-content">
                <li>订户的物理或电子签名；</li>
                <li>识别已移除或禁用访问的材料以及在被移除或禁用访问之前出现的材料的位置；</li>
                <li>声明，声明人宣誓作伪证，声称订阅者真诚地相信，由于对要删除或禁用的材料的错误或误认，该材料已被删除或禁用；以及</li>
                <li>订户的姓名、地址和电话号码，以及声明订户同意受其地址所在司法管辖区联邦地区法院管辖，或如果订户的地址位于美国境外，则同意受四川活力糖科技有限公司可能所在地的任何司法管辖区管辖，并且订户接受根据上述第9.d条通知的人或该人的代理人送达法律程序。</li>
                
            </ul>
            <p class="text-content">提交反通知的一方应咨询律师或查阅17 U.S.C. ？512，以确认根据《版权法》提供有效反通知的party_x0019_s义务。</p>
            <p class="text-content">如果您向四川活力糖科技有限公司提交反通知以回应涉嫌侵权通知，则四川活力糖科技有限公司将及时向提供涉嫌侵权通知的人士提供您的反通知副本，并告知该人士四川活力糖科技有限公司将在10个工作日内替换被删除的用户内容或反馈，并停止对其访问，或在收到反通知后至少10个工作日且不超过14个工作日内替换被删除的用户内容或反馈并停止对其访问，除非四川活力糖科技有限公司 版权代理人收到提交涉嫌侵权通知的一方的通知，该方已提起诉讼，要求法院命令禁止用户从事与四川活力糖科技有限公司 系统或网络上的材料相关的侵权活动。</p>
            <p class="text-content">美国版权法（17 U.S.C. ？512(f)）规定：</p>
            <p class="text-content">任何明知故犯地在[《版权法》第512节（17 U.S.C. ？512）]下(1)虚假陈述某材料或活动构成侵权，或(2)错误地声称某材料或活动已被移除或禁用的人，均应对因该虚假陈述而遭受的任何损害负责，包括成本和attorneys_x0019_费用，这些损害由被指控的侵权者、任何版权所有者或版权owner_x0019_s授权的被许可人，或因服务提供商依赖该虚假陈述而移除或禁用涉嫌侵权材料或活动，或替换已移除的材料或停止禁用访问所造成的损害。</p>
            <p class="text-content">四川活力糖科技有限公司保留权利，向任何提交侵权声明或违反法律的反通知（17 U.S.C. ？512(f)）的当事人索赔损害赔偿的权利。</p>
            
            <h3 class="section-title">K.使用限制和规则：</h3>
            <p class="text-content">
                作为您使用本服务的条件，且不限制您根据本服务条款承担的其他义务，您同意遵守本节及我们《可接受使用政策》中规定的使用限制和规则，该政策也是本服务条款的一部分，以及本服务中规定的任何额外限制或规则（如特定应用程序的规则）。
            </p>
            <p class="text-content">
                本服务仅供您个人和非商业用途使用。您不得修改、复制、分发、传输、展示、表演、再现、出版、许可、创作衍生作品、反向工程、转让或出售本服务的任何部分、使用本服务或访问本服务，除非适用法律允许的有限反向工程活动。
            </p>
            <p class="text-content">
                您负责配置您的信息技术、计算机程序和平台以访问服务，并且您应该使用自己的病毒防护软件。
            </p>
            <p class="text-content">
                您不得滥用服务，故意引入病毒、木马、蠕虫、逻辑炸弹或其他恶意或技术有害的材料。您不得试图未经授权访问服务、网站或存储服务的移动应用程序，以及与服务连接的任何服务器、计算机或数据库。您不得通过拒绝服务攻击或分布式拒绝服务攻击攻击服务。违反此条款者将构成刑事犯罪。我们将向相关执法部门报告此类违规行为，并配合这些部门披露您的身份。一旦发生违规行为，您使用服务的权利将立即终止。
            </p>

            <h3 class="section-title">L.虚拟货币和商品：</h3>
            <p class="text-content">
                服务可能包括虚拟货币，如现金、硬币、积分或类似物品，这些可以通过服务获得或以法定货币或其他实际货币购买，但需遵守适用法律（此类虚拟货币，[虚拟货币]）。服务还可能包括虚拟数字物品，如资产、商品、能力或其他物品，这些可以通过服务获得或以法定货币或其他实际货币购买，或以虚拟货币购买，但需遵守适用法律（此类虚拟物品，[虚拟商品]）。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司保留绝对权利，随时自行决定管理、监管、控制、修改或删除虚拟货币和/或虚拟商品，四川活力糖科技有限公司对行使上述权利不承担任何责任。您仅限于使用在服务中获得的虚拟商品和虚拟货币，且该使用须在授权范围内进行。您对服务中出现或源自的服务中的任何此类虚拟商品或虚拟货币没有其他权利、权益或利益。
            </p>
            <p class="text-content">
                你特此承认并同意，除服务明确授权外，严禁转让虚拟货币和虚拟商品。在服务之外，你不应向四川活力糖科技有限公司、任何其他服务用户或任何其他方出售、兑换或以其他方式转让虚拟货币或虚拟商品。
            </p>
            <p class="text-content">
                您同意所有虚拟货币和虚拟商品的销售均为最终销售，除非四川活力糖科技有限公司根据其唯一且绝对的判断决定不予退款。您承认并同意，在这些使用条款终止时，无论出于何种原因，包括四川活力糖科技有限公司 服务或其适用部分因任何原因停止提供，您的账户或服务将被取消，所有虚拟货币和虚拟商品将归您所有，四川活力糖科技有限公司对此不承担任何责任。
            </p>

            <h3 class="section-title">M.在其他网站上发布信息并链接到服务：</h3>
            <p class="text-content">
                根据这些使用条款，四川活力糖科技有限公司同意授予您有限的、可撤销的、非独占的、不可转让的许可，以发布您的个人账户资料信息，如您在构成服务一部分的应用程序中的成就，以及其他由四川活力糖科技有限公司书面授权的服务材料，仅限于非商业目的，并且仅在您的个人网站或第三方网站上发布，前提是该第三方网站允许用户发布此类内容。
            </p>
            <ul class="text-content">
                <li class="text-content">1.不是 四川活力糖科技有限公司的商业竞争对手，</li>
                <li class="text-content">2.不批评，或采取其他可能合理预期对四川活力糖科技有限公司造成损害的行动，</li>
                <li class="text-content">3.除了在您的指示下发布该内容的非独占许可外，不得获得对该发布内容的任何权利，</li>
                <li class="text-content">4.不向访问此类内容收取费用，也不将产品、服务或广告与此类内容关联，且</li>
                <li class="text-content">5.与所有链接的网站一起，遵守所有适用法律，不对任何第三方的知识产权或其他任何形式的权利构成任何威胁或侵犯，并且不托管、发布、分发、传播或促进任何内容，如果用户在服务上发布的任何内容违反了这些使用条款（每个这样的第三方网站都是[授权网站]）。</li>
            </ul>
            <p class="text-content">
                上述许可明确要求您在每篇这样的帖子中都附上两者
            </p>
            <ul class="text-content">
                <li class="text-content">1.链接到vitalitysugar-game.com和</li>
                <li class="text-content">2.在发布内容出现的每一页上都附有声明[版权所有 四川活力糖科技有限公司。经许可使用]。</li>
            </ul>
            <p class="text-content">
                四川活力糖科技有限公司同意授予您一项非独占、有限的许可，该许可可由四川活力糖科技有限公司自行决定撤销，允许您从任何授权网站链接到四川活力糖科技有限公司的首页。未经四川活力糖科技有限公司明确书面许可，您不得在框架内或[内嵌链接]中显示服务或其任何部分。
            </p>

            <h3 class="section-title">N.我们如何使用您的个人信息</h3>
            <p class="text-content">
                我们非常重视您的隐私。我们只会按照规定使用您的个人信息。请查阅我们的隐私政策，以确保您了解我们的做法。
            </p>

            <h3 class="section-title">O.终止：</h3>
            <p class="text-content">
                这些使用条款将一直有效，直到任何一方终止。
            </p>
            <h3 class="section-title">您终止合同的权利：</h3>
            <ul class="text-content">
                <li class="text-content">1.通过联系 四川活力糖科技有限公司通知我们您终止服务。</li>
                <li class="text-content">2.删除或以其他方式销毁所有与服务有关的材料。</li>
                <li class="text-content">3.停止使用服务。</li>
            </ul>
            <h3 class="section-title">我们终止合同的权利：</h3>
            <p class="text-content">
                四川活力糖科技有限公司可随时以任何理由终止本使用条款、您的账户及您对服务的访问（或根据四川活力糖科技有限公司 的唯一选择，终止服务的适用部分）。四川活力糖科技有限公司可在其自行决定的情况下，在任何此类终止之前向您发出警告或其他通知，例如当您违反本使用条款时。然而，您确认，在根据本条款进行任何此类终止之前，四川活力糖科技有限公司没有义务向您提供此类通知或警告。
            </p>
            <h3 class="section-title">您的账号停用或终止：</h3>
            <p class="text-content">
                如果你的账户已停用一年或更长时间，四川活力糖科技有限公司有权自行决定关闭或终止你的账户。你进一步同意，在关闭或终止账户时，四川活力糖科技有限公司可能会删除你的内容和信息，并不会以任何方式将这些内容归还给你。四川活力糖科技有限公司不对因删除你的内容或信息而产生的任何损害或后果负责。保存任何内容的责任完全由你自己承担。四川活力糖科技有限公司会考虑多个因素来判断你是否仍在访问你的账户，这些因素包括你上次访问日期。
            </p>
            <h3 class="section-title">违反条款的后果：</h3>
            <p class="text-content">
                此外，如果四川活力糖科技有限公司怀疑或确定您可能
            </p>
            <ul class="text-content">
                <li class="text-content">1.未能遵守本《使用条款》的任何规定或四川活力糖科技有限公司制定的任何政策或规则；或</li>
                <li class="text-content">2.参与与或在使用服务过程中可能违法或导致责任、损害、尴尬、骚扰、滥用或扰乱您、四川活力糖科技有限公司、任何第三方或服务本身的行为。</li>
            </ul>
            <h3 class="section-title">终止后果：</h3>
            <p class="text-content">
                由于终止，你可能会失去你的账号和与之相关的所有信息和数据，包括但不限于你的用户名、头像、应用内角色和成就、虚拟货币和虚拟商品，视情况而定。
            </p>
            <p  class="text-content">您承认并同意，根据本使用条款，无论因您还是四川活力糖科技有限公司的原因，在任何情况下终止服务时，您无权获得退款、补偿或其他赔偿，四川活力糖科技有限公司也不对您或任何第三方承担责任。如果四川活力糖科技有限公司终止您的账户，未经四川活力糖科技有限公司 明确书面许可，您不得参与该服务或任何其他四川活力糖科技有限公司的服务。如需请求终止后参与四川活力糖科技有限公司服务的许可，请通过以下方式提交申请：bravedefense@yeah.net四川活力糖科技有限公司保留拒绝向任何个人提供账号及向四川活力糖科技有限公司提供服务的权利。您不得允许已被四川活力糖科技有限公司终止账号的个人使用您的账号。</p>
        
            <h3 class="section-title">P.与他人发生争执：</h3>
            <p class="text-content">
                您对与本服务的其他用户以及通过本服务与您接触的其它方的互动负全责。四川活力糖科技有限公司特此免除您或任何第三方因使用本服务而产生的任何责任。
            </p>
            <p class="text-content">
                您将与四川活力糖科技有限公司充分合作，调查任何涉嫌非法、欺诈或不当的行为，包括但不限于授予四川活力糖科技有限公司访问您账户中任何密码保护部分的权限。四川活力糖科技有限公司保留权利，但没有义务监控和管理您与其他服务用户之间的纠纷。
            </p>
            <h3 class="section-title">Q.免责声明：</h3>
            <p class="text-content">
                您明确同意，您使用本服务的风险由您自行承担，本服务是按[原样]和[可用]提供，不附带任何保证。
            </p>
            <p class="text-content">
                四川活力糖科技有限公司（下文定义）特此声明，对于服务、服务材料以及所有用户内容，包括但不限于任何非侵权、所有权、适销性或特定用途适用性的隐含保证，本公司不承担任何明示或暗示的保证。
            </p>
            <p class="text-content">
                不以限制上述一般性为限，并在法律允许的范围内，四川活力糖科技有限公司各方不作任何保证。
            </p>
            <ul class="text-content">
                <li>1.服务将满足您的要求或者服务材料或用户内容将可供您查看。</li>
                <li>2.服务将不间断、及时、安全或无错误，或者错误将得到纠正。</li>
                <li>3.使用服务或任何服务材料或用户内容所获得的结果将准确或可靠。</li>
            </ul>
            <p class="text-content">
                [ 四川活力糖科技有限公司]由 四川活力糖科技有限公司及其附属公司和子公司组成，以及其各名高级职员、董事、雇员、代理人、供应商和许可方。
            </p>
            <h3 class="section-title">R.责任限额：</h3>
            <p class="text-content">
                在任何情况下，四川活力糖科技有限公司均不对您因使用本服务或与本服务相关的任何直接、间接、偶发、后果性、特殊、示范性、惩罚性或其他损害而产生的损失负责，包括但不限于收入损失、利润损失、数据丢失或业务中断等无形损失，无论这些损害是基于保证、合同、侵权（包括疏忽）或其他任何法律理论，无论四川活力糖科技有限公司的任何一方是否已被告知此类损害的可能性。如果您对服务不满意，唯一的补救措施是停止使用该服务。
            </p>
            <p class="text-content">
                在任何情况下， 四川活力糖科技有限公司对与服务有关的所有索赔的总责任都不会超过索赔前12个月内您向四川活力糖科技有限公司支付的金额中较高者，即50美元或您支付的金额。
            </p>
            <p class="text-content">
                某些司法管辖区不允许排除某些保证或限制和排除对某些类型损害的责任。因此，上述部分限制和免责声明可能不适用于您。就四川活力糖科技有限公司或任何其他四川活力糖科技有限公司方而言，根据适用法律，不得以任何方式排除任何保证、限制或免除其责任或本服务条款中规定的保证的范围和期限， 四川活力糖科技有限公司 及该等四川活力糖科技有限公司Party_x0019_s责任应为适用法律下的最低限度。
            </p>
            <h3 class="section-title">S.指向外部位置和第三方网站的链接：</h3>
            <p class="text-content">
                服务可能包含指向第三方网站或资源的链接。您承认并同意，四川活力糖科技有限公司不对此负责或承担责任。
            </p>
            <ul class="text-content">
                <li>1.此类网站或资源的可用性或准确性。</li>
                <li>2.这些网站或资源上的内容、产品或服务。</li>
            </ul>
            <p class="text-content">
                链接到此类网站或资源并不意味着四川活力糖科技有限公司对这些网站或资源及其提供的内容、产品或服务有任何背书。您承认对使用任何此类网站或资源负全责，并承担由此产生的所有风险。四川活力糖科技有限公司可随时因任何原因或无故删除任何链接。
            </p>
            <h3 class="section-title">T.赔偿：</h3>
            <p class="text-content">
                您将负责并同意赔偿、保护和使四川活力糖科技有限公司各方免受任何第三方因或源于
            </p>
            <ul class="text-content">
                <li>1.您帐户中的信息以及您（或使用您的密码访问服务的任何人）通过服务提交、发布或传输的任何信息，</li>
                <li>2.您（或使用您的密码访问服务的任何人）对服务的使用，</li>
                <li>3.您（或使用您的密码访问服务的任何人）违反了这些使用条款或任何适用的附加使用条款或第三方协议，以及</li>
                <li>4.您（或使用您的密码访问服务的任何人）侵犯任何其他个人或实体的任何权利。</li>
            </ul>
            <h3 class="section-title">U.适用于本合同的法律以及您可向何处提起诉讼：</h3>
            <p class="text-content">
                本使用条款及任何与此或服务相关的行动均受加利福尼亚州法律管辖，不考虑其冲突法规条款。如因本使用条款引发任何诉讼，各方同意接受位于加利福尼亚州圣克拉拉县的所有联邦和州法院的个人管辖权，并同意这些法院为此类诉讼的唯一审理地。各方明确放弃适用《联合国国际货物销售合同公约》。您承认，在这些使用条款下授予给四川活力糖科技有限公司的权利和义务具有独特性和不可替代性，其丧失可能导致对四川活力糖科技有限公司造成即时且不可弥补的损害，而法律上的补救措施不足以弥补。因此，如果发生您违约或预期违约的情况，四川活力糖科技有限公司有权寻求禁令或其他衡平救济（无需提供任何保证金或担保）。您不可撤销地放弃寻求禁令或其他衡平救济的权利。任何根据这些条款提出的索赔均不适用。使用须在诉讼原因发生后的一年内(1)内提交。如果您是欧盟境内的消费者，则上述关于适用法律和管辖权的规定不适用。如果您是欧盟境内的消费者，本使用条款将受您所在国家的法律和司法管辖。
            </p>
            <h3 class="section-title">V.其他重要术语：</h3>
            <h3 class="section-title">互联网和数据费用：</h3>
            <p class="text-content">
                您同意负责获取和维护所有电话、计算机硬件移动设备和其他用于访问和使用服务所需的设备，并承担与此相关的所有费用。
            </p>
            <h3 class="section-title">美国以外的服务访问：</h3>
            <p class="text-content">
                四川活力糖科技有限公司在美国设有办公室，负责运营和管理该服务。四川活力糖科技有限公司不保证该服务适用于其他地区或可在那里使用。该服务提供的信息和材料并非为任何人在任何司法管辖区分发或使用而准备，这些地区如果分发或使用违反法律或法规，或者会使四川活力糖科技有限公司在该司法管辖区或国家面临任何注册要求，则不适用。因此，选择从其他地区访问该服务的人士需自行决定，并独自承担遵守当地法律的责任，如果适用的话。
            </p>
            <h3 class="section-title">出口控制：</h3>
            <p class="text-content">
                服务的部分内容可能受美国出口管制。您同意遵守此类出口管制，以及任何适用司法管辖区内的类似管制。除上述限制外，您同意不得下载、出口或再出口服务中的任何软件。
            </p>
            <ul class="text-content">
                <li>1.进入（或居住在）古巴、伊拉克、朝鲜、伊朗、叙利亚或其他美国已禁止向其出口商品的国家。</li>
                <li>2.对美国财政部Department_x0019_s特别指定国民名单或美国商务部Department_x0019_s拒绝令表上的任何人。</li>
            </ul>
            <p class="text-content">
                通过下载任何软件或适用的服务部分，您声明并保证您不在受控于或属于任何此类国家或国家或居民名单上。
            </p>
            <h3 class="section-title">无关系：</h3>
            <p class="text-content">
                您同意，由于这些使用条款或您使用服务，您与 四川活力糖科技有限公司之间不存在任何合资企业、合伙关系、雇佣关系或代理关系。
            </p>

            <h3 class="section-title">这些条款是我们之间的完整协议：</h3>
            <p class="text-content">
                本使用条款构成您与四川活力糖科技有限公司就您使用服务和本协议的任何其他主题达成的完整协议，除四川活力糖科技有限公司在网站或移动应用程序上明确发布的条款外，您不得更改或修改本协议。
            </p>
            <h3 class="section-title">即使我们推迟执行此合同，我们仍然可以在稍后执行：</h3>
            <p class="text-content">
                四川活力糖科技有限公司未能行使或执行本《使用条款》中的任何权利或条款，不构成放弃该等权利或条款，任何一方对本协议项下的任何违约或失职行为的放弃，不视为放弃任何先前或后续的违约或失职行为。
            </p>
            <h3 class="section-title">如果法院认定本合同的一部分是非法的，其余部分将继续生效：</h3>
            <p class="text-content">
                如果任何条款被有管辖权的法院认定无效，双方仍同意法院应努力执行该条款所反映的parties_x0019_意图，且本使用条款的其他条款将继续完全生效。双方的行为或商业惯例均不得修改本使用条款。
            </p>
            <h3 class="section-title">我们可以将本合同转让给其他人：</h3>
            <p class="text-content">
                未经四川活力糖科技有限公司事先书面同意，您不得转让本使用条款，但四川活力糖科技有限公司可自由转让本使用条款。
            </p>
            <h3 class="section-title">还有一些术语：</h3>
            <p class="text-content">
                本文所用的章节标题仅用于方便之目的，不应赋予任何法律效力。如四川活力糖科技有限公司提出要求，您须向四川活力糖科技有限公司提供所有必要的文件、证明或声明，以验证您遵守这些使用条款。您同意，这些使用条款不会因起草方而对四川活力糖科技有限公司产生不利影响。您特此放弃基于这些使用条款电子形式以及双方未签署以执行这些使用条款的所有抗辩。非本协议一方的人士无权强制执行其任何条款。
            </p>
            <h3 class="section-title">本合同终止后，本条款仍然有效：</h3>
            <p class="text-content">
                您同意，本使用条款的以下部分将在本使用条款、您的账户或服务终止后继续有效：F节（服务材料、所有权、商标和反馈）、H节（您的内容）、O节（终止）、P节（与其他人的纠纷）、Q节（免责声明）、R节（责任限制）、T节（赔偿）、U节（适用于本合同的法律以及您可提起诉讼的地方）和V节（其他重要条款）。
            </p>
            <h3 class="section-title">联系我们：</h3>
            <p class="text-content">
                所有通信请通过以下方式联系我们bravedefense@yeah.net
            </p>
            <h3 class="section-title">可接受使用政策</h3>
            <p class="text-content">
                请在使用我们的服务前仔细阅读本政策条款
            </p>
            <h3 class="section-title">此可接受使用政策包含哪些内容？</h3>
            <p class="text-content">
                本可接受使用政策（“政策”）规定了您上传内容至我们的服务、与其他用户建立联系、链接到我们的移动应用或网站，或以任何其他方式与我们的服务互动时适用的内容标准。本政策是我们的使用条款的一部分，应与我们的服务条款一并阅读。
            </p>
            <h3 class="section-title">禁止用途</h3>
            <p class="text-content">
                您只能出于合法目的使用我们的服务。您同意不使用本服务来传输、提供或以其他方式推广或支持：
            </p>
            <ul class="text-content lidian">
                <li>任何未经请求或未经授权的广告、宣传材料、[垃圾邮件，][垃圾邮件，][连锁信，][金字塔骗局，]或任何形式的招揽；</li>
                <li>任何间谍软件、被动收集机制或任何其他充当被动或主动信息收集或传输机制的代码或材料；</li>
                <li>作弊、破解、恶意程序、病毒或其他任何计算机代码、文件或程序，这些行为旨在或可能修改、损害、干扰、破坏、妨碍或限制服务或其任何部分的功能，控制任何计算机软件、硬件或电信设备，或中断任何user_x0019_s不间断使用和享受服务的行为；</li>
                <li>未发布的服务内容（如游戏内物品或装备）、通过破解客户端数据文件解锁的区域，或无法通过正常操作或游戏玩法在服务的任何部分获得的数据。</li>
            </ul>
            <p class="text-content">
                您进一步同意不：
            </p>
            <ul class="text-content lidian">
                <li>干扰或破坏服务或与服务连接的服务器或网络，或不遵守与服务连接的网络的任何要求、程序、政策或规定；</li>
                <li>干扰、破坏或规避服务的任何安全功能或限制或强制执行对服务的使用或访问的任何功能；</li>
                <li>故意或无意地违反适用的任何地方、州、国家或国际法律；</li>
                <li>利用服务以任何方式伤害未成年人；</li>
                <li>使用服务来披露有关其他个人的任何个人信息，包括可用于跟踪、联系或冒充该个人或冒充您的身份的任何信息；</li>
                <li>欺诈或误导 四川活力糖科技有限公司或其他用户，或以其他方式从事任何可疑活动；</li>
                <li>利用本服务从事任何商业活动，包括但不限于为任何一方或任何目的筹集资金，或宣传、推广或试图交易或销售网站、金字塔计划、多层次营销计划、指向其他网站的网络链接或任何其他产品或服务；</li>
                <li>冒充任何人或实体，或者虚假陈述或以其他方式歪曲您与某人或实体的关系，或者给人的印象，您的任何内容都来自 四川活力糖科技有限公司，如果事实并非如此；</li>
                <li>通过自动化手段或虚假借口创建任何账户，在每个设备上创建多个账户，或使用任何其他user_x0019_s账户进行任何用途，包括规避暂停或禁令；</li>
                <li>作弊或使用、开发或分发自动化软件程序（[机器人]）、[宏]软件程序或其他[作弊工具]软件程序或应用程序，其目的是修改 四川活力糖科技有限公司 Limited的体验，损害公平竞争；</li>
                <li>以法定货币或其他实际货币，或其它有价商品、服务或物品交换，出售或转让本服务（或其任何部分）、您的帐户或您对帐户的访问权。</li>
            </ul>
            <p class="text-content">
                您还同意不访问服务：
            </p>
            <ul class="text-content lidian">
                <li>通过 四川活力糖科技有限公司提供的用于访问服务的界面以外的任何方式；</li>
                <li>通过任何自动化手段（包括使用任何脚本、网络爬虫、机器人、蜘蛛或抓取程序）；</li>
                <li>通过伪造或篡改标识符以掩盖任何访问服务的行为来源。鉴于互联网的全球性，您同意遵守所有关于在线行为和可接受用户内容的地方规定，并同意遵守所有有关从美国或您所在国家出口的技术数据传输的适用法律。</li>
            </ul>
            <h3 class="section-title">互动服务</h3>
            <p class="text-content">
                我们可在服务中提供交互功能，包括但不限于：
            </p>
            <ul class="text-content lidian">
                <li>在游戏贡献和消息中</li>
                <li>聊天室</li>
                <li>评论/留言板</li>
                <li>在线论坛</li>
            </ul>
            <p class="text-content">
                （“互动服务”）
            </p>
            <h3 class="section-title">内容标准</h3>
            <p class="text-content">
                用任何互动服务时，您还同意以下内容标准：
            </p>
            <p class="text-content">
                用户内容（或其部分）不得：
            </p>
            <ul class="text-content lidian">
                <li>非法、有害、威胁、辱骂、骚扰、侵权、诽谤、粗俗、淫秽、冒犯、煽动性、诽谤性、侵犯another_x0019_s隐私、欺骗性、欺凌、侮辱、羞辱、煽动暴力、仇恨、基于种族、宗教、国籍、残疾或年龄的歧视性、贬低或不适当的行为；</li>
                <li>促进非法活动，如吸毒；</li>
                <li>包括您根据任何法律或合同或信托关系或违反对第三方的任何法律义务而无权提供的内容，例如合同义务或保密义务；</li>
                <li>侵犯任何一方的专利、商标、商业秘密、版权或其他知识产权、专有或其他权利。</li>
            </ul>
            <p class="text-content">
                您还同意不：
            </p>
            <ul class="text-content lidian">
                <li>过度使用相同的短语、相似的短语或胡言乱语；</li>
                <li>在其他用户之间制造不必要的不满或骚动，例如挑起争端、在论坛上发离题帖子或侮辱服务的其他用户；</li>
                <li>发表或发送非建设性评论；</li>
                <li>滥用任何功能，通过发送虚假警报或无意义的信息向四川活力糖科技有限公司报告；</li>
                <li>在论坛上发帖；</li>
                <li>发布多条消息或发布其他非贡献性消息，例如IBTL（即，在锁定之前）、TLDR（即，[太长；didn_x0019_t阅读]）或[First！]消息；</li>
                <li>删除离题评论；</li>
                <li>承诺采取 四川活力糖科技有限公司认为，根据其自行判断，属于[辱骂]、[恶搞]或[垃圾邮件]的其他行为；</li>
                <li>针对现有主题创建新主题或为在多个论坛（例如交叉发布）中进一步讨论而将现有主题拆分为多个主题；</li>
                <li>链接到其他论坛的帖子，除非事先得到管理员的批准</li>
            </ul>
            <h3 class="section-title">违反本政策</h3>
            <p class="text-content">
                这些使用规则并非详尽无遗，我们保留决定哪些行为违反了使用规则或超出服务精神的权利，并采取相应行动。一旦我们认为发生了违反本政策的行为，我们可以采取我们认为适当的措施。
            </p>
            <p class="text-content">
                不遵守本政策即构成对您使用我们服务所依据的《使用条款》的重大违反，可能会导致我们采取以下全部或任何行动：
            </p>
            <ul class="text-content lidian">
                <li>立即、暂时或永久地撤销您使用我们的服务的权利。</li>
                <li>立即、临时或永久删除您上传到我们的服务的任何用户内容。</li>
                <li>向您发出警告。</li>
                <li>因违约而产生的所有赔偿费用（包括但不限于合理的行政和法律费用）将根据赔偿要求向您提起诉讼，要求您偿还所有费用。</li>
                <li>进一步针对你的法律行动。</li>
                <li>向执法部门披露我们认为合理或法律要求的此类信息。</li>
            </ul>
            <p class="text-content">
                我们不承担因违反本政策而采取的所有行动的责任。我们可能采取的行动不限于上述描述，我们还可能采取我们认为适当的任何其他行动。
            </p>
        </div>
    </div>
<Foorm/>
</div>
</template>
<script>
    import Foorm from '@/components/fooret.vue';
    import tops from '@/components/top.vue';
    export default{
        components: {
            Foorm,
            tops
        },
        data() {
           return {
            }   
        },
        methods:{

        },
        watch:{
            '$store.state.EnZh':function(){
                if(this.$store.state.EnZh==true){
                    this.$router.push('/en_fwtk');
                }else{
                    this.$router.push('/fwtk');
                }
            }
        }
    }
</script>
<style scoped lang="scss">
.fwtk_box{
    width: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 70px;
    .wenwen_de_img{
        position: absolute;
        width: 100%;
        z-index: 1;
    }
    .zc_text{
        width: 60%;
        overflow-y: auto;
        // padding-top:50px;
        margin-bottom: 50px;
        // background-color: aqua;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: column;
        color: #323232;
        padding-right: 20px;
    }
    .zc_text::-webkit-scrollbar{
        display:none;/*隐藏滚动条*/
    } 
.zc_text::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background: rgba(29,29,38,.7);
}
/*定义滚动条轨道*/
.zc_text::-webkit-scrollbar-track {
		box-shadow: inset 0 0 0px rgba(255, 255, 255, 0.5);
		border-radius: 10px;
		background: rgba(29,29,38,.7);
}
/*定义滑块*/
.zc_text::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 0px rgba(255, 255, 255, 0.5);
		background-color: rgba(255, 255, 255, 0.5);
}
    .section-title {
    font-weight: bold;
    margin-top: 20px;
    font-size: 16.5px;
    }
    .text-content {
        line-height: 1.8;
        text-indent: 2em;
        a{
            color: #fff;
        }
    }
    .lidian>li::before {
        content: "•"; /* 替换为自定义符号 */
        width: 10px;
        margin-right: 8px;
    }
   
}

</style>